<template>
  <div style="margin-top:30px">
    <el-form ref="form" :rules="rules" :model="form" label-width="100px">
                          
      <el-row>
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <el-form-item label="名称" prop="linkName" style="margin-right:15px">
              <el-input v-model="form.linkName" placeholder="请输入名称" />
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <el-form-item label="链接地址" prop="linkUrl" style="margin-right:15px">
              <el-input v-model="form.linkUrl" placeholder="请输入链接地址" />
            </el-form-item>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="funcCancel">取 消</el-button>
      <el-button type="primary" @click="funcSubmit">确 定</el-button>
    </div>
  </div>
</template>
<script>
    import request from '@/utils/request'
    export default {
        name: 'FriendsLinkAdd',
        data() {
            return {
                form: {
                code: '',
                userCode: '',
                branchCode: '',
                linkName: '',
                linkUrl: '',
                },
                rules: {
                  
                    linkName: [
                        { required: true, message: '请输入名称', trigger: 'blur' },
                        { min: 1, max: 50, message: '长度在 1 到 255 个字符', trigger: 'blur' }
                    ],
                    linkUrl: [
                        { required: true, message: '请输入邮件', trigger: 'blur' },
                        { min: 1, max: 50, message: '长度在 1 到 1000 个字符', trigger: 'blur' }
                    ],
                }
            }
        },
        created() {},
        methods: {
            //提交
            funcSubmit() {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        const data = this.form
                        request({ url: '/ntocc-basic-api/friendsLink', method: 'post', params: data }).then(response => {
                            this.$message({ message: response.msg, type: 'success' })
                            this.$emit('fatherAddMethod')
                        }).then(()=>this.$refs['form'].resetFields())
                    } else {
                        return false
                    }
                })
            },
            //取消
            funcCancel() {
                this.$emit('fatherCancelMethod','add')
            }
        }
    }
</script>
<style lang="scss" scoped>
    .dialog-footer {
        margin:15px 0 15px 0;
        width: 175px;
        float: right;
    }
</style>
